import { render } from "./DataBase.vue?vue&type=template&id=aac8a5ea&scoped=true"
import script from "./DataBase.vue?vue&type=script&lang=js"
export * from "./DataBase.vue?vue&type=script&lang=js"

import "./DataBase.vue?vue&type=style&index=0&id=aac8a5ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac8a5ea"],['__file',"src/components/admin/DataBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aac8a5ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aac8a5ea', __exports__)) {
    api.reload('aac8a5ea', __exports__)
  }
  
  module.hot.accept("./DataBase.vue?vue&type=template&id=aac8a5ea&scoped=true", () => {
    api.rerender('aac8a5ea', render)
  })

}


export default __exports__